import { CookieCategory } from '../../domain/cookie-consent.model';

const GM_GROUP = 'Gastro Management Group';

export const COOKIE_CATEGORIES: readonly CookieCategory[] = [
  {
    id: 'essential',
    icon: 'lock-closed-outline',
    nameKey: 'cookieConsent.essentialName',
    descKey: 'cookieConsent.essentialDesc',
    cookies: [
      {
        name: 'auth0.*',
        provider: 'Auth0 Inc.',
        purposeKey: 'cookieConsent.purposeAuth0',
        expiryKey: 'cookieConsent.expiryAuth0',
      },
      {
        name: 'gm_cookie_consent',
        provider: GM_GROUP,
        purposeKey: 'cookieConsent.purposeConsent',
        expiryKey: 'cookieConsent.expiry1Year',
      },
    ],
  },
  {
    id: 'analytics',
    icon: 'bar-chart-outline',
    nameKey: 'cookieConsent.analyticsName',
    descKey: 'cookieConsent.analyticsDesc',
    switchLabelKey: 'cookieConsent.enableAnalytics',
    cookies: [
      {
        name: '_ga, _ga_*',
        provider: 'Google LLC (Analytics)',
        purposeKey: 'cookieConsent.purposeGa',
        expiryKey: 'cookieConsent.expiryGa',
      },
    ],
  },
  {
    id: 'functional',
    icon: 'options-outline',
    nameKey: 'cookieConsent.functionalName',
    descKey: 'cookieConsent.functionalDesc',
    switchLabelKey: 'cookieConsent.enableFunctional',
    cookies: [
      {
        name: 'gm_lang',
        provider: GM_GROUP,
        purposeKey: 'cookieConsent.purposeLang',
        expiryKey: 'cookieConsent.expiry1Year',
      },
      {
        name: 'dmca.com (Bild)',
        provider: 'DMCA.com',
        purposeKey: 'cookieConsent.purposeDmca',
        expiryKey: 'cookieConsent.expiryNone',
      },
    ],
  },
];
